<button rds-dropdown-toggle-secondary-button size="l" [rdsMenuTriggerFor]="createMenu">{{label}}</button>
<rds-menu #createMenu="rdsMenu" xPosition="after" size="l" class="app-menu">
  <button rds-menu-item size="l" rnbBackButtonSet
          *ngFor="let item of options" (click)="select(item)">
    {{item.label}}
  </button>
</rds-menu>
